export class LoadStateConstant {
    static LOADSTATE_PENDING_CONTROL_ID = "PENDING_CONTROL";
    static LOADSTATE_CONTROL_IN_PROGRESS_ID = "CONTROL_IN_PROGRESS";
    static LOADSTATE_DISEMBARKED_ID = "DISEMBARKED";
    static LOADSTATE_EMBARKED_ID = "EMBARKED";
    static LOADSTATE_NOT_EMBARKED_ID = "NOT_EMBARKED";
    static LOADSTATE_NOT_DISEMBARKED_ID = "NOT_DISEMBARKED";
    static LOADSTATE_REPORT_ID = "REPORT";
  
    static MATERIAL_STATE_OPTIONS = [
      { label: "En attente de contrôle", value: this.LOADSTATE_PENDING_CONTROL_ID },
      { label: "Contrôle en cours", value: this.LOADSTATE_CONTROL_IN_PROGRESS_ID },
      { label: "Débarqué", value: this.LOADSTATE_DISEMBARKED_ID },
      { label: "Embarqué", value: this.LOADSTATE_EMBARKED_ID },
      { label: "Non embarqué", value: this.LOADSTATE_NOT_EMBARKED_ID },
      { label: "Non débarqué", value: this.LOADSTATE_NOT_DISEMBARKED_ID },
      { label: "Signaler", value: this.LOADSTATE_REPORT_ID },
    ];
  }
  
  export const getLoadStateTagData = (id: string) => {
    const option = LoadStateConstant.MATERIAL_STATE_OPTIONS.find(
      (opt) => opt.value === id
    );
    let color = "default";
    switch (id) {
        case LoadStateConstant.LOADSTATE_PENDING_CONTROL_ID:
          color = "orange";
          break;
        case LoadStateConstant.LOADSTATE_CONTROL_IN_PROGRESS_ID:
          color = "blue";
          break;
        case LoadStateConstant.LOADSTATE_DISEMBARKED_ID:
          color = "green";
          break;
        case LoadStateConstant.LOADSTATE_NOT_DISEMBARKED_ID:
          color = "geekblue";
          break;
        case LoadStateConstant.LOADSTATE_EMBARKED_ID:
          color = "lime";
          break;
        case LoadStateConstant.LOADSTATE_NOT_EMBARKED_ID:
          color = "purple";
          break;
        case LoadStateConstant.LOADSTATE_REPORT_ID:
          color = "red";
          break;
      }
      
    return { label: option?.label || id, color };
  };
  